import React, { useRef, useEffect, useState } from "react"
import { Container } from "@inlet/react-pixi"
import Anticipation from "components/anticipation"
import FadeIn from "components/fade-in"
import FadeOut from "components/fade-out"

const Anticipations = ({ config }) => {
  const old = useRef([])
  const mem = useRef(config)
  const [counter, setCounter] = useState(0)
  useEffect(() => {
    old.current = [].concat(mem.current)
    mem.current = [].concat(config)
    setCounter(prev => prev + 1)
  }, [config])
  return (
    <Container alpha={0.8}>
      <Anticipation x={-100} y={60} />
      {config.map(m => (
        <FadeIn key={m}>
          <Anticipation key={m} x={m * 60} y={60} />
        </FadeIn>
      ))}
      {old.current
        //.filter(f => !config.includes(f))
        .map(m => (
          <FadeOut key={m}>
            <Anticipation x={m * 60} y={60} />
          </FadeOut>
        ))}
    </Container>
  )
}

export default Anticipations
